import {
  AccumulaterData,
  contentsData
} from 'src/components/searchBox/SearchTypes';

import { ContentMetaData } from '../ConsumptionHelper/types';

export const railsReducer = (content: ContentMetaData) =>
  content?.contents?.reduce(
    (railsData: AccumulaterData, contentData: contentsData) => {
      if (contentData?.id) {
        if (railsData?.railIDs?.length) {
          railsData.railIDs += ',';
        }
        railsData.railIDs += contentData.id;
      }

      if (contentData?.title) {
        if (railsData?.railElements?.length) {
          railsData.railElements += ',';
        }
        railsData.railElements += contentData.title;
      }

      return railsData;
    },
    { railIDs: '', railElements: '' }
  );
